/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { dealflowAdvisoryMemberDtoSchema } from "./dealflowAdvisoryMemberDtoSchema.ts";
import { dealflowCapTableEntryDtoSchema } from "./dealflowCapTableEntryDtoSchema.ts";
import { z } from "zod/v4";

export const dealflowTeamInfoDtoSchema = z.object({
  foundersEquityPct: z.optional(z.number()),
  totalFte: z.optional(z.int()),
  numberOfEmployees: z.optional(z.int()),
  get advisoryBoard() {
    return z.array(dealflowAdvisoryMemberDtoSchema).optional();
  },
  get capTable() {
    return z.array(dealflowCapTableEntryDtoSchema).nullish();
  },
});
